<app-card [loading]="(loading$ | async) ?? false">
  <div class="header">
    <button
      type="button"
      class="button icon-button filter-button-mobile"
      (click)="openFilterDialog()"
    >
      <app-icon name="ic_filter" />
      {{ "default.filter" | translate }}
    </button>
  </div>

  <ng-template #filterFields>
    <div class="filter-fields flex gap-2" [formGroup]="filterForm">
      <div class="filter-group">
        <div class="flex wrap">
          <app-input-wrapper [control]="filterForm.controls['searchTerm']">
            <app-icon input-wrapper-icon-start name="ic_search" />
            <input
              type="search"
              formControlName="searchTerm"
              [placeholder]="'default.search' | translate"
            />
          </app-input-wrapper>

          <app-input-wrapper
            isSelect
            [control]="filterForm.controls['sortOrder']"
          >
            <app-icon name="ic_sort" input-wrapper-icon-start />
            <select formControlName="sortOrder">
              @for (
                sortOption of filterOptions.sortOrder;
                track sortOption.value
              ) {
                <option [value]="sortOption.value">
                  {{ sortOption.label | translate }}
                </option>
              }
            </select>
          </app-input-wrapper>
        </div>
      </div>

      <div class="filter-group">
        <div class="flex wrap">
          <app-date-range-input formControlName="dateRange" />
        </div>
      </div>

      <div class="filter-group">
        <div class="flex wrap">
          <label class="filter-label only-mobile">{{
            "actionLog.filter.result.label" | translate
          }}</label>
          @for (
            resultOption of filterOptions.result;
            track resultOption.value;
            let i = $index
          ) {
            <app-input-wrapper [control]="filterForm.controls['result']">
              <input
                [id]="resultOption.value ?? i"
                [value]="resultOption.value"
                type="radio"
                formControlName="result"
              />
              <label [for]="resultOption.value ?? i">{{
                resultOption.label | translate
              }}</label>
            </app-input-wrapper>
          }
        </div>
      </div>
    </div>
  </ng-template>

  @if (!isFilterDialogOpen) {
    <div class="header filter-desktop">
      <ng-container *ngTemplateOutlet="filterFields" />
    </div>
  }
  <div class="content">
    <table>
      <thead>
        <tr>
          <th>{{ "actionLog.list.eventDate" | translate }}</th>
          <th>{{ "actionLog.list.action" | translate }}</th>
          <th>{{ "actionLog.list.object" | translate }}</th>
          <th>{{ "actionLog.list.trigger" | translate }}</th>
          <th></th>
          <th>{{ "actionLog.list.result" | translate }}</th>
        </tr>
      </thead>
      <tbody>
        @for (entry of actionLog$ | async; track entry.eventId) {
          <tr>
            <td>
              {{ entry.eventDate | localizedDate }},
              {{ entry.eventDate | time }}
            </td>
            <td>
              {{
                LabelConverter.getActionLogActionLabel(entry.action) | translate
              }}
            </td>
            <td>
              {{
                LabelConverter.getActionLogObjectTypeLabel(entry.objectType)
                  | translate
              }}:
              @if (entry.objectName) {
                @if (
                  getObjectRoute(
                    entry.objectType,
                    entry.objectId,
                    entry.objectName
                  );
                  as objectRoute
                ) {
                  <a class="link" [routerLink]="objectRoute">{{
                    entry.objectName
                  }}</a>
                } @else {
                  {{ entry.objectName }}
                }
              }
            </td>
            <td>
              {{
                LabelConverter.getActionLogTriggerLabel(entry.trigger)
                  | translate
              }}
            </td>
            <td>
              {{
                entry.userEmail || entry.client
                  ? (entry.userEmail || "") +
                    (entry.userEmail && entry.client ? " | " : "") +
                    (entry.client || "")
                  : "-"
              }}
            </td>
            <td>
              <app-tag
                size="small"
                [level]="entry.result"
                [matTooltip]="entry.errorMessage"
              >
                {{
                  LabelConverter.getActionLogResultLabel(entry.result)
                    | translate
                }}
                @if (entry.errorMessage) {
                  <app-icon [size]="IconSize.SM" name="ic_info" />
                }
              </app-tag>
            </td>
          </tr>
        } @empty {
          <tr>
            <td colspan="100%">
              {{ "actionLog.list.empty" | translate }}
            </td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="footer">
    <app-pagination
      [pageSize]="filterForm.value.pageSize"
      [totalCount]="totalCount$ | async"
      [currentPage]="filterForm.value.page"
      (pageChange)="onChangePage($event)"
      [loading]="loading$ | async"
    />
  </div>
</app-card>
